export const plans = {
  // Header
  title: 'Choose a Plan',
  subtitle: 'You can change or cancel your plan anytime. Each month is renewed on the 25th for the following month.',

  // Free mode (FREE_MODE active)
  freeTitle: 'EachTeach is currently free to use',
  freeDescription: 'During the testing period, every feature is available for free. No payment is required. Plan selection and billing will begin once paid plans go live.',
  freeCta: 'Go to My Page',

  // Active subscription banner
  activeBanner: 'Your plan is currently active. Pick a plan below to change it.',

  // Plan shared
  perMonthUnit: ' / month',
  popularBadge: 'Popular',
  selectButton: 'Choose this plan',
  processing: 'Processing...',
  checkoutError: 'Failed to create checkout',
  freeModeError: 'Free mode is active, so checkout cannot be created.',

  // Plan definitions
  basicName: 'Basic',
  basicDesc: '4 lessons a month. A relaxed way to get started.',
  plus2Name: 'Plus 2',
  plus2Desc: '6 lessons a month. For keeping up a steady 1–2 times a week.',
  plus4Name: 'Plus 4',
  plus4Desc: '8 lessons a month. For focused, intensive progress.',

  // Notes
  note1: 'First 2 lessons are free (with a feedback survey).',
  note2: 'One unused lesson can roll over to the next month.',
  note3: 'Cancel by the 15th to stop billing from the next month.',
  note4: 'Special pricing applies during the testing period.',
};
